/*
  Kalessie - Notify Me (back in stock). Shows a trigger when the selected
  variant is sold out (mirrors Dawn's ATC disabled state, re-checked on variant
  change), opens a slide-up sheet with a Shopify customer form. The form tags
  the subscriber so a Shopify Flow can email them when stock returns.
*/
(function () {
  class KalNotify extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.kal-notify__trigger');
      this.modal = this.querySelector('.kal-notify__modal');
      this.atc = document.querySelector('[id^="ProductSubmitButton-"]');
      if (this.trigger) this.trigger.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this._onKey = (e) => { if (e.key === 'Escape') this.close(); };
      document.addEventListener('keydown', this._onKey);

      this.tagsInput = this.querySelector('[data-kal-tags]');
      this.noteInput = this.querySelector('[data-kal-note]');
      this.productTitle = (this.querySelector('.kal-notify__product') || {}).textContent || '';

      this.sync();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.atc = document.querySelector('[id^="ProductSubmitButton-"]');
          var variant = event && event.data && event.data.variant;
          if (variant) this.setVariant(variant);
          this.sync();
        });
      }

      // Re-open after a successful submit (Shopify reloads with ?customer_posted=true).
      try {
        if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') this.open();
      } catch (e) {}
    }
    disconnectedCallback() { document.removeEventListener('keydown', this._onKey); }
    setVariant(variant) {
      if (this.tagsInput) {
        var base = this.tagsInput.getAttribute('data-kal-tag-base') || 'back-in-stock';
        this.tagsInput.value = base + '-' + variant.id;
      }
      if (this.noteInput) {
        this.noteInput.value = 'Back in stock request — ' + this.productTitle.trim() + ' / ' + (variant.title || '') + ' (variant ' + variant.id + ')';
      }
    }
    sync() {
      var soldout = this.atc ? !!this.atc.disabled : false;
      if (this.trigger) this.trigger.hidden = !soldout;
    }
    open() { if (this.modal) { this.modal.hidden = false; document.body.style.overflow = 'hidden'; } }
    close() { if (this.modal) { this.modal.hidden = true; document.body.style.overflow = ''; } }
  }
  if (!customElements.get('kal-notify')) customElements.define('kal-notify', KalNotify);
})();
